export enum CookieKey {
  app = 'app',
  snapshot = 'snapshot',
  // todo: remove when httpOnly
  auth = 'auth',
  refresh = 'refresh',
  authSession = 'authSession',
}

export enum SidebarState {
  mini = 'mini',
  full = 'full',
}

export enum DragDropEngine {
  click = 'click',
  touch = 'touch',
}
